import type { AdminAuditsResponse } from '@/api/(admin)/audits/types';
import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

/**
 * Pure RPC for the admin audits list.
 *
 * `GET /api/admin/audits` (same `{ data, meta }` envelope), migrated out of
 * the legacy audits-service `GET /v1/admin/audits`, which no longer exists.
 * Paging, sort and filters are built in the hook and arrive as a query string.
 */
export async function fetchAdminAudits(
  qs: string,
): Promise<AdminAuditsResponse> {
  return apiFetch<AdminAuditsResponse>(
    `/api/admin/audits?${qs}`,
    {},
    API_ROOT_URL,
  );
}
